export default {
    /* 'eleicoes-legislativas-2023': {
        view: 'elections',
        type: 'legislative',
        year: 2023,
        title: 'Eleições Legislativas 2023',
        results: 'legislative2023',
        candidates: true,
        compare: 2017,
        hash: true
    }, */
    'eleicoes-autarquicas-2021': {
        view: 'elections',
        type: 'municipal',
        year: 2021,
        title: 'Eleições Autárquicas 2021',
        results: 'municipal2021',
        compare: 2017,
        hash: true,
        dev: {
            partidos: true,
            info: true
        }
    },
    'eleicoes-autarquicas-2021-candidatos': {
        view: 'candidates',
        type: 'municipal',
        year: 2021,
        title: 'Candidatos 2021',
        results: 'municipal2021'
    },
    'eleicoes-autarquicas-2021-mini-resultados': {
        view: 'elections',
        type: 'municipal',
        year: 2021,
        title: 'Eleições Autárquicas 2021',
        results: 'municipal2021',
        lite: true
    },
    'eleicoes-legislativas-2019': {
        view: 'elections',
        type: 'legislative',
        year: 2019,
        title: 'Eleições Legislativas 2019',
        results: 'legislative2019',
        hash: true
    },
    'eleicoes-autarquicas-2017': {
        view: 'elections',
        type: 'municipal',
        year: 2017,
        title: 'Eleições Autárquicas 2017',
        results: 'municipal2017',
        hash: true,
        dev: {
            compare: 2013
        }
    },
    'eleicoes-autarquicas-2017-mini-resultados': {
        view: 'elections',
        type: 'municipal',
        year: 2017,
        title: 'Eleições Autárquicas 2017',
        results: 'municipal2017',
        lite: true,
        hash: true
    },
    'eleicoes-autarquicas-2013': {
        view: 'elections',
        type: 'municipal',
        year: 2013,
        title: 'Eleições Autárquicas 2013',
        results: 'municipal2013'
    },
    'mapa': {
        view: 'map',
        title: 'Mapa'
    },
    'eleicoes-autarquicas-2017-2013': {
        view: 'elections',
        type: 'municipal',
        year: 2017,
        title: 'Eleições Autárquicas 2017 - 2013',
        results: 'municipal2017',
        hash: true,
        compare: 2013
    },
    /* 'exemplo': {
        view: 'candidates',
        type: 'municipal',
        year: 2021,
        title: 'Candidatos das Eleições Autárquicas 2021',
        results: 'municipal2021',
        candidates: true, //mostra tab de candidatos
        news: 'https://link.do.feed/',
        kpis: 'widget-dos-candidatos',
        types: true, //mostra tipos do mapa
        info: true, //modal de detalhes dos avatares (candidatos)
        hash: true, //atualiza a hash do url
        partidos: true, // mostra detalhe de partidos
        more: 'https://link.mais/resultados', // link mais resultados 

    }, */
}